import { createAction, props } from '@ngrx/store';
import { PerformanceAnalysisJobFilter } from '../../enums/performance-analysis-job-filter.enum';
import { PerformanceAnalysisPeriod } from '../../enums/performance-analysis-period.enum';
import {
  PerformanceAnalysisData,
  PerformanceAnalysisFilters,
  PerformanceAnalysisQuery,
} from '../../interfaces/performance-analysis.interface';

export const loadPerformanceAnalysisFilters = createAction(
  '[PerformanceAnalysis/API] Load Filters'
);

export const loadPerformanceAnalysisFiltersSuccess = createAction(
  '[PerformanceAnalysis/API] Load Filters Success',
  props<{ filters: PerformanceAnalysisFilters }>()
);

export const loadPerformanceAnalysisFiltersFailure = createAction(
  '[PerformanceAnalysis/API] Load Filters Failure',
  props<{ error: unknown }>()
);

export const loadPerformanceAnalysis = createAction(
  '[PerformanceAnalysis/API] Load Performance Analysis',
  props<{ query: PerformanceAnalysisQuery }>()
);

export const loadPerformanceAnalysisSuccess = createAction(
  '[PerformanceAnalysis/API] Load Performance Analysis Success',
  props<{ data: PerformanceAnalysisData }>()
);

export const loadPerformanceAnalysisFailure = createAction(
  '[PerformanceAnalysis/API] Load Performance Analysis Failure',
  props<{ error: unknown }>()
);

export const setPerformanceAnalysisJobFilter = createAction(
  '[PerformanceAnalysis/UI] Set Job Filter',
  props<{ jobFilter: PerformanceAnalysisJobFilter; jobId?: number }>()
);

export const setPerformanceAnalysisPeriod = createAction(
  '[PerformanceAnalysis/UI] Set Period',
  props<{
    period: PerformanceAnalysisPeriod;
    startDate?: string;
    endDate?: string;
  }>()
);

export const exportPerformanceAnalysisCsv = createAction(
  '[PerformanceAnalysis/API] Export CSV'
);

export const exportPerformanceAnalysisCsvSuccess = createAction(
  '[PerformanceAnalysis/API] Export CSV Success',
  props<{ csv: string }>()
);

export const exportPerformanceAnalysisCsvFailure = createAction(
  '[PerformanceAnalysis/API] Export CSV Failure',
  props<{ error: unknown }>()
);

export const exportPerformanceAnalysisPdf = createAction(
  '[PerformanceAnalysis/API] Export PDF'
);

export const exportPerformanceAnalysisPdfSuccess = createAction(
  '[PerformanceAnalysis/API] Export PDF Success',
  props<{ blob: Blob }>()
);

export const exportPerformanceAnalysisPdfFailure = createAction(
  '[PerformanceAnalysis/API] Export PDF Failure',
  props<{ error: unknown }>()
);

export const clearPerformanceAnalysis = createAction(
  '[PerformanceAnalysis/API] Clear Performance Analysis'
);
